import {
  IconAuction,
  IconBell,
  IconEnvironment,
  IconFileText,
  IconHome,
  IconLogout,
  IconSettings,
  IconSportCar,
  IconSupport,
  IconUser,
} from "@/components/icons";
import { global_settings } from "@/config";
import { paths } from "@/config/paths";

import type { PlanUser } from "@/services/plans/get-user-plan";
import type { UserMenuItem } from "@/types/const";
import type { TFunction } from "i18next";

export function getUserMenuItems(
  t: TFunction,
  garageChildren: UserMenuItem[],
  logout: () => void,
  openSupport: () => void,
  showThemeModal: () => void,
  openProfile: () => void,
  openNotifications?: () => void,
  openBilling?: () => void,
  plans?: PlanUser | undefined,
  notificationCount = 0
): UserMenuItem[] {
  const auctionEnabled =
    Boolean(plans?.config?.auction_analytics) ||
    (plans?.name ? plans.name.toLowerCase() === "professional" : false);

  return [
    {
      label: t("header.dashboard"),
      to: paths.app.dashboard.getHref(),
      icon: <IconHome size={22} />,
      group: 1,
    },
    {
      label: t("header.your_garages"),
      to: null,
      isDropdown: garageChildren.length > 0 ? true : false,
      icon: <IconSportCar size={22} />,
      group: 1,
      children: garageChildren,
    },
    {
      label: t("header.market"),
      to: paths.app.markets.root.getHref(),
      icon: <IconEnvironment size={22} />,
      group: 1,
    },
    {
      label: t("header.auctions"),
      to: paths.app.auction.root.getHref(),
      icon: <IconAuction size={22} />,
      group: 1,
      hide: !auctionEnabled,
    },
    {
      label: t("header.documents"),
      to: paths.app.documents.getHref(),
      icon: <IconFileText size={22} />,
      group: 1,
    },
    {
      label: t("header.notifications"),
      to: null,
      icon: <IconBell size={22} />,
      group: 2,
      onClick: openNotifications,
      numericIndicator: notificationCount,
    },
    {
      label: t("header.your_profile"),
      to: paths.app.profile.getHref(),
      icon: <IconUser size={22} />,
      onClick: openProfile,
      group: 2,
    },
    {
      label: t("header.billing"),
      to: null,
      icon: <IconFileText size={22} />,
      onClick: openBilling,
      group: 2,
      hide: !global_settings.enablePayments,
    },
    {
      label: t("header.settings"),
      to: null,
      icon: <IconSettings size={22} />,
      onClick: showThemeModal,
      group: 2,
    },
    {
      label: t("header.support"),
      to: null,
      icon: <IconSupport size={22} />,
      group: 2,
      onClick: openSupport,
    },
    {
      label: t("header.logout"),
      to: null,
      icon: <IconLogout size={22} />,
      group: 2,
      onClick: logout,
      isLogout: true,
    },
  ];
}
